var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSchedule = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  fillRule: "evenodd",
  d: "M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18m2.9-5.7.3.1c.2 0 .5 0 .6-.3.2-.3 0-.7-.2-1L9.4 9.4V5A.7.7 0 1 0 8 5v4.6c0 .2.1.4.3.5l3.6 2.1Z",
  clipRule: "evenodd"
})));
export default SvgSchedule;